import React, { useEffect, useRef, useState } from 'react';
import QRCode from 'qrcode';

interface QrCodeImageProps {
  value: string;
  size?: number;
}

export default function QrCodeImage({ value, size = 200 }: QrCodeImageProps) {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!canvasRef.current || !value) return;
    setError(false);
    QRCode.toCanvas(canvasRef.current, value, { width: size, margin: 1 }, (err) => {
      if (err) setError(true);
    });
  }, [value, size]);

  if (error) {
    return (
      <div className="alert alert-error">
        <span>Unable to render QR code. Use the manual entry key below.</span>
      </div>
    );
  }

  return <canvas ref={canvasRef} width={size} height={size} className="rounded bg-white p-2" />;
}
